import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";

import ContentSpinner from "@/components/ContentSpinner";
import { PageHeading } from "@/components/Layout/Parts";
import Text from "@/components/Text";
import useAlerts from "@/hooks/useAlerts";
import { SerpSearchResource } from "@/types/resources";
import { api } from "@/utils/api";
import ProductsTable from "./components/ProductsTable";
import BackButton from "@/components/BackButton";

const StyledPageHeading = styled(PageHeading)`
  max-width: 800px;
`;

const AmazonListSingle = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const alerts = useAlerts();

  const { isLoading, data: searchData } = useQuery<SerpSearchResource>(
    ["amazon_search", { id }],
    () => api.get<never, SerpSearchResource>(`/v1/amazon-searches/${id}`),
    {
      staleTime: 60 * 1000,
      retry: 2,
      onError: (err) => {
        if ((err as any).response.status === 404) {
          return navigate("/404", {
            replace: true,
          });
        }
        alerts.error();
      },
    }
  );

  if (isLoading || !searchData) {
    return <ContentSpinner />;
  }

  return (
    <>
      <Text $color="gray" $type="caption">
        AMAZON PRODUCTS SERP
      </Text>
      <StyledPageHeading>{searchData.name}</StyledPageHeading>
      <BackButton />
      <ProductsTable />
    </>
  );
};

export default AmazonListSingle;
